<template>
  <div>
    <div>
      <!-- ueditor
      <vue-ueditor-wrap v-model="text" :config="editorConfig"></vue-ueditor-wrap> -->
      <!-- <button @click="test">test</button> -->
    </div>
  </div>

</template>

<script>
  // import VueUeditorWrap from 'vue-ueditor-wrap'

  export default {
    // components: {
    //   VueUeditorWrap
    // },
    data() {
      return {
        text: ''
        // editorConfig: {
        //   autoHeightEnabled: false, //编译器不自动被内容撑高
        //   initialFrameHeight: 350, //初始容器高度
        //   initialFrameWith: 900,
        //   // serverUrl: "/api/ueditor/net/controller.ashx", //上传文件地址
        //   UEDITOR_HOME_URL: "/static/UEditor/", //UEditor资源文件的存放路径
        // },
      }
    },
    created() {
      // this.axios.defaults.baseURL = '/getIP'
      // this.axios.post('/cityjson?ie=utf-8/', {}).then(res => {
      //   // var returnCitySN = {"cip": "111.196.122.150", "cid": "110000", "cname": "北京市"};
      //   let index = res.data.search("{")
      //   let data = JSON.parse(res.data.slice(index, -1))
      //   console.log('ip', data)
      // })
      // this.axios.defaults.baseURL = '/api'

    },
    methods: {
      async test() {
        // console.log(this.axios.defaults.headers['token'])
        // let res = await this.axios.get('/test')
        // console.log('token', localStorage.getItem('token'))
        let res = this.axios.post('/opLog')
        console.log(res)
      },

    }
  }

</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/home/HomeMain.vue